module.exports = __webpack_public_path__ + "images/payment-rate.2ec4baa77bd48e2f100717d118ec2755.png";